'use strict';

var encodings = new Set(['json', 'buffer', 'string']);

module.exports = function (mkrequest) {
  return function () {
    var statusCodes = new Set();
    var method;
    var encoding;
    var headers;
    var baseurl = '';

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args.forEach(function (arg) {
      if (typeof arg === 'string') {
        if (arg.toUpperCase() === arg) {
          if (method) {
            var msg = "Can't set method to ".concat(arg, ", already set to ").concat(method, ".");
            throw new Error(msg);
          } else {
            method = arg;
          }
        } else if (arg.startsWith('http:') || arg.startsWith('https:')) {
          baseurl = arg;
        } else {
          if (encodings.has(arg)) {
            encoding = arg;
          } else {
            throw new Error("Unknown encoding, ".concat(arg));
          }
        }
      } else if (typeof arg === 'number') {
        statusCodes.add(arg);
      } else if (typeof arg === 'object') {
        if (headers) {
          throw new Error('Cannot set headers twice.');
        }

        headers = arg;
      } else {
        throw new Error("Unknown type: ".concat(typeof arg));
      }
    });
    if (!method) method = 'GET';

    if (statusCodes.size === 0) {
      statusCodes.add(200);
    }

    return mkrequest(statusCodes, method, encoding, headers, baseurl);
  };
};